import React from 'react';
import ViewItems from '../../../components/ViewItems';
import Text from '../../../components/Text';
import { fontSizes } from '../../../constants/constants';
import dynamicfunction from '../../../utils/dynamicfunction';
import ViewReverse from '../../../components/ViewReverse';
import { ReactSVG } from 'react-svg';
import icons from '../../../constants/icons';

const SingleDocumentView = ({ label, getContentKey, onView, onClick }) => {
  const { TextWeight } = dynamicfunction();
  return (
    <ViewItems className='rounded-2xl sm:rounded-2xl border border-grey p-2.5 sm:p-3 w-full'>
      <Text
        text={label}
        size={fontSizes.h14}
        weight={TextWeight.semiBold}
        color='text-black'
        isTruncate={false}
      />

      <ViewReverse className='gap-3 mt-4 flex-wrap'>
        <ViewReverse
          className='justify-center cursor-pointer items-center gap-3 border border-primary rounded-lg py-2 px-5 flex-1'
          onClick={onView}
        >
          <ReactSVG src={icons?.view_icon} />
          <Text
            text={getContentKey('view')}
            color='text-primary'
            isTruncate={false}
          />
        </ViewReverse>
        <ViewReverse
          className='justify-center cursor-pointer items-center gap-3 border border-primary rounded-lg py-2 px-5 flex-1'
          onClick={() => onClick()}>
          <ReactSVG src={icons?.download_icon} />
          <Text
            text={getContentKey('download')}
            color='text-primary'
            isTruncate={false}
          />
        </ViewReverse>
      </ViewReverse>
    </ViewItems>
  );
};

export default SingleDocumentView;
